(function () {
  'use strict';

  console.log('[Moshimo] tracking script loaded');

  function moshimoGetRdCode() {
    try {
      var urlParams = new URLSearchParams(window.location.search);
      var rdCode = urlParams.get('rd_code');

      // URLにrd_codeがある場合
      if (rdCode && /^[a-zA-Z0-9_-]+$/.test(rdCode)) {

        document.cookie =
          'pure_moshimo_rd_code=' +
          encodeURIComponent(rdCode) +
          '; path=/; max-age=' +
          (60 * 60 * 24 * 30) +
          '; SameSite=Lax';

        document.cookie =
          'pure_moshimo_clicked_at=' +
          Date.now() +
          '; path=/; max-age=' +
          (60 * 60 * 24 * 30) +
          '; SameSite=Lax';

        console.log(
          '[Moshimo] rd_code captured:',
          rdCode
        );

        return rdCode;
      }

      // URLにrd_codeがない場合は保存済みCookieを確認
      var match = document.cookie.match(
        /(?:^|;\s*)pure_moshimo_rd_code=([^;]+)/
      );

      if (match) {
        var savedRdCode = decodeURIComponent(match[1]);

        console.log(
          '[Moshimo] saved rd_code:',
          savedRdCode
        );

        return savedRdCode;
      }

      return null;

    } catch (error) {

      console.error(
        '[Moshimo] rd_code取得エラー:',
        error
      );

      return null;
    }
  }


  // ==========================================
  // Moshimo rd_codeをShopify Cart Attributeへ保存
  // ==========================================
  function moshimoSyncCartAttribute(rdCode) {

    if (!rdCode) {
      return Promise.resolve(null);
    }

    var clickedAtMatch = document.cookie.match(
      /(?:^|;\s*)pure_moshimo_clicked_at=([^;]+)/
    );

    var clickedAt = clickedAtMatch
      ? decodeURIComponent(clickedAtMatch[1])
      : '';

    console.log(
      '[Moshimo] Cart Attribute保存開始:',
      rdCode
    );

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          pure_moshimo_rd_code: rdCode,
          pure_moshimo_clicked_at: clickedAt
        }
      })
    })
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Cart Attribute update failed: ' +
          response.status
        );
      }

      return response.json();
    })
    .then(function (cart) {

      console.log(
        '[Moshimo] Cart Attribute保存完了:',
        cart.attributes
      );

      return cart;

    })
    .catch(function (error) {

      console.error(
        '[Moshimo] Cart Attribute保存エラー:',
        error
      );

      return null;
    });
  }


  // ==========================================
  // 初期処理
  // ==========================================

  var rdCode = moshimoGetRdCode();

  // URLにrd_codeが含まれている場合のみ
  // Shopify Cart Attributeへ保存
  var hasRdCodeInUrl =
    new URLSearchParams(window.location.search).get('rd_code');

  if (
    hasRdCodeInUrl &&
    rdCode
  ) {
    moshimoSyncCartAttribute(rdCode);
  }

})();